import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

const PaymentFailPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const code = searchParams.get('code');
    const message = searchParams.get('message') || '알 수 없는 오류';

    // ✅ 부모창에 실패 통지
    if (window.opener) {
      window.opener.postMessage({ type: 'PAYPAL_FAIL', reason: message, code }, window.location.origin);
      window.close();
      return;
    }

    alert(`결제에 실패했습니다.\n사유: ${message} (코드: ${code})`);
    navigate('/schedule-contact');
  }, [searchParams, navigate]);

  return (
    <div style={{ display:'flex', justifyContent:'center', alignItems:'center', height:'100vh' }}>
      <h2>결제에 실패하여 이전 페이지로 돌아갑니다.</h2>
    </div>
  );
};

export default PaymentFailPage;
